import { render, staticRenderFns } from "./propagateOverview.vue?vue&type=template&id=8d54d10a&scoped=true&"
import script from "./propagateOverview.vue?vue&type=script&lang=js&"
export * from "./propagateOverview.vue?vue&type=script&lang=js&"
import style0 from "./propagateOverview.vue?vue&type=style&index=0&id=8d54d10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d54d10a",
  null
  
)

export default component.exports